<template>
    <div
        class="board"
        :style="{
            flexDirection: direction === 'horizontal' ? 'row' : 'column',
        }"
    >
        <div v-for="node in tree" class="node" :key="node.id">
            <button
                :class="'node-header ' + (active == node.id ? 'selected' : '')"
                @click="$emit('select', node.id)"
            >
                <strong>{{ node.name }}</strong>
            </button>
            <template v-if="multipleVariants(node)">
                <div class="node-body">
                    <div
                        v-for="(children, variant) in node.children"
                        class="board-variant"
                        :key="variant"
                    >
                        <div class="variant-name">{{ variant }}</div>
                        <board
                            :tree="children"
                            direction="vertical"
                            :active="active"
                            @select="
                                (id) => {
                                    $emit('select', id);
                                }
                            "
                        />
                    </div>
                </div>
            </template>
            <template v-else>
                <div
                    v-for="(children, variant) in node.children"
                    :key="variant"
                >
                    <board
                        :tree="children"
                        direction="vertical"
                        :active="active"
                        @select="
                            (id) => {
                                $emit('select', id);
                            }
                        "
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<style scoped lang="scss">
.board {
    display: flex;
    font-size: 12px;
    width: 100%;
    background: #eeee;
    border-radius: 10px;
    .node {
        padding: 20px;
        border: 1px solid #ddd;
        flex-grow: 1;
        &:first-child {
            border-radius: 10px 0 0 10px;
        }
        &:last-child {
            border-radius: 0 10px 10px 0;
        }
    }
    .node-header {
        background: #fff;
        padding: 10px;
        margin-bottom: 10px;
        border: none;
        display: block;
        border-radius: 3px;
        width: 100%;
        text-align: left;
        &.selected {
            background: var(--primary);
            color: #fff;
        }
    }
    .variant-name {
        margin-top: 10px;
        color: #888;
    }
    ::v-deep {
        .board {
            border: none;
            .node {
                border: none;
                padding-left: 20px;
                padding-top: 0;
                padding-bottom: 0;
                padding-right: 0;
            }
        }
        .board-variant > .board > .node {
            padding-left: 0;
        }
    }
}
</style>
<script>
export default {
    name: "board",
    props: {
        active: String,
        tree: {
            type: Array,
            required: true,
        },
        direction: {
            type: String,
            default: "horizontal",
        },
    },
    methods: {
        multipleVariants(node) {
            return Object.keys(node.children).length > 1;
        },
    },
};
</script>
